// TYPE MESSAGE
export const SUCCESS = "success";
export const ERROR = "error";
// SUCCESS MESSAGE
export const SUCCESS_GET_DATA = "Successfully loaded data";
export const SUCCESS_GET_DATA_LIST = "Successfully loaded list";
export const SUCCESS_GET_DATA_DETAIL = "Successfully loaded detail";
export const SUCCESS_ADD_DATA = "Successfully added";
export const SUCCESS_EDIT_DATA = "Successfully edited";
export const SUCCESS_REMOVE_DATA = "Successfully deleted";
export const SUCCESS_SUBMIT_DATA = "Successfully submitted";
export const SUCCESS_EMAIL_SENT_TO_USER = "Email successfully sent to user";
export const SUCCESS_ASSIGN_ROLE = "Successfully assigned role to user";
export const SUCCESS_GENERATE_REPORT = "Successfully generated report";
// ERROR MESSAGE
export const ERROR_GET_DATA = "Failed to load data";
export const ERROR_GET_DATA_LIST = "Failed to load list";
export const ERROR_GET_DATA_DETAIL = "Failed to load detail";
export const ERROR_ADD_DATA = "Failed to add";
export const ERROR_EDIT_DATA = "Failed to edit";
export const ERROR_REMOVE_DATA = "Failed to remove";
export const ERROR_SUBMIT_DATA = "Failed to submit";
export const ERROR_EMAIL_SENT_TO_USER = "Failed to send email to user";
export const ERROR_ASSIGN_ROLE = "Failed to assign role to user";
export const ERROR_GENERATE_REPORT = "Failed to generate report";
export const ERROR_SEARCH_MIN_LENGTH =
  "Search length must be at least 3 characters long";
